import PageContainer from '../../../../components/common/PageContainer';
import ESRPendingTable from './Table';

const ESRCreatedAndPendingPage = () => {
  return (
    <>
      <PageContainer 
        title='My Dashboard + Tasks' 
        subTitle='My MRRF & JO'
        submoduleTitle='JO Created, Pending Approval'  
        showDate
      >
        <ESRPendingTable />
      </PageContainer>
    </>
  );
}

export default ESRCreatedAndPendingPage;